import { render, staticRenderFns } from "./TagsAndNotesUpdateModal.vue?vue&type=template&id=c670b980&"
import script from "./TagsAndNotesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TagsAndNotesUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports